<template>
  <v-card>
    <v-card-title class="headline grey lighten-2"> Pay Now </v-card-title>
    <v-card-text class="">
      <div class="table-div overflow-auto">
        <table class="table">
          <thead>
            <tr class="table-success">
              <th>Sr. no</th>
              <th>Billing month and year</th>
              <th>Centre counts</th>
              <th class="text-right">Pay per use changes</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Jan 2022</td>
              <td>5</td>
              <td class="text-right">&#8377; 200</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Jan 2022</td>
              <td>5</td>
              <td class="text-right">&#8377; 200</td>
            </tr>
            <tr>
              <td colspan="4">
                <div class="d-align amount-checkbox">
                  <v-checkbox
                    label="Unbilled amount"
                    hide-details
                    class="mt-0"
                  ></v-checkbox>
                  <span class="text-dark font-weight-bold ml-2">
                    &#8377; 200</span
                  >
                </div>
                <div class="d-align amount-checkbox">
                  <p class="mb-0">Total amount</p>
                  <span class="text-dark font-weight-bold ml-2">
                    &#8377; 200</span
                  >
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" @click="$emit('close')">Cancel</v-btn>
      <v-btn color="success" @click="paymentsDetails = true">Pay</v-btn>
    </v-card-actions>
    <v-dialog
      persistent
      v-model="paymentsDetails"
      scrollable
      width="800"
      hide-overlay
    >
      <payments-details @close="paymentsDetails = false" />
    </v-dialog>
  </v-card>
</template>
<script>
const paymentsDetails = () =>
  import("@/views/payPerUse/modals/paymentsDetails");

export default {
  data() {
    return {
      paymentsDetails: false,
    };
  },
  components: {
    paymentsDetails,
  },
};
</script>

<style  lang="scss">
.amount-checkbox {
  justify-content: flex-end;
  .v-input {
    .v-label {
      margin-bottom: 0;
    }
  }
}
</style>